<router-outlet></router-outlet>
<iframe id="downloadIframe" name="downloadFrame" style="visibility:hidden;display:none"></iframe>
<iframe id="download-iframe"></iframe>
<form name="downloadform" id="downloadform" method="post" target="downloadFrame" action="url">
</form>
@if (!universalService.isMobileDevice && this.router.url != '/'  && !this.router.url.includes('albums/')) {
  <ngx-guided-tour
    skipText=""
    doneText="Understood"
    tourStepWidth="300"
    minimalTourStepWidth="275"
    progressIndicator=" "
    backText =""
  class="ngx-guided-tour"></ngx-guided-tour>
}
